const { useCallback, useState } = require('react');

const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const { useI18n } = require('nordic/i18n');
const { Title } = require('@andes/typography');
const { RadioList, RadioListItem } = require('@andes/radio-list');
const { Card, CardContent } = require('@andes/card');

const { UserAddressCard } = require('../Components/UserAddressCard');
const stepActions = require('../../../spa/actions/step');
const { getQueryParams } = require('../../../utils/Dom');
const { STEP_NEXT } = require('../../../spa/actions/types');
const { DEVICE_TYPE } = require('../../../../constants/commons');
const translate = require('../../../translation');
const { parseAmount } = require('../../../utils/currency');
const { FooterAction } = require('../Components/FooterAction');

const ShippingOptionsV2 = (props) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const { flow, data, history, stepAction, configs } = props;
  const { shipping_option, zipcode_text } = data;
  const { currency, deviceType } = configs;

  const isMobile = deviceType === DEVICE_TYPE.MOBILE;
  const isDesktop = deviceType === DEVICE_TYPE.DESKTOP;
  const [selectedShippingOption, setSelectedShippingOption] = useState(
    shipping_option.options[0].id,
  );

  const handleSelectShippingOption = useCallback((shippingOption) => {
    setSelectedShippingOption(shippingOption);
  }, []);

  const handleNextStep = useCallback(() => {
    const urlParams = getQueryParams();

    const defaultData = {
      urlParams,
      type: flow.type,
    };

    const payload = {
      isNewInterface: true,
      selected_shipping_id: String(selectedShippingOption),
    };

    stepAction[STEP_NEXT](
      payload,
      flow.id,
      defaultData,
      flow.type,
      urlParams,
      history,
    );
  }, [flow, history]);

  return (
    <>
      <section className="shipping-generics shipping-address-form-v2">
        <Title size="xs" className="mt-40i mb-32i" component="div">
          {translations.SHIPPING_OPTIONS_TITLE}
        </Title>
        <div className="mb-24">
          <UserAddressCard isMobile={isMobile} address={zipcode_text} />
        </div>
        <Card shadow={isMobile && 'elevated'} className="mb-32">
          <CardContent className="d-flex d-flex-column g-32">
            <RadioList
              defaultValue={selectedShippingOption}
              name="shipping-options"
              srLabel={translations.SHIPPING_OPTIONS_TITLE}
              withDividers
              // eslint-disable-next-line react/jsx-no-bind
              onChange={(_, value) => handleSelectShippingOption(value)}
            >
              {shipping_option?.options?.map(({ id, name, cost }) => (
                <RadioListItem
                  key={id}
                  title={name}
                  description={isMobile && parseAmount(cost, currency)}
                  value={id}
                  className="shipping-option-item"
                  rightContent={isDesktop && parseAmount(cost, currency)}
                />
              ))}
            </RadioList>
          </CardContent>
        </Card>
        <FooterAction
          isMobile={isMobile}
          continueAction={handleNextStep}
          isContinueActionVisible
        />
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  flow: state.page.flow,
  configs: state.configurations,
});

const mapDispatchToProps = (dispatch) => ({
  stepAction: bindActionCreators(stepActions, dispatch),
});

module.exports = {
  ShippingOptionsV2: connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ShippingOptionsV2),
};
